import type { InputHTMLAttributes } from 'react'

interface ToggleProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
  label?: string
  hint?: string
  checked: boolean
  onCheckedChange: (next: boolean) => void
}

export function Toggle({ label, hint, checked, onCheckedChange, id, ...rest }: ToggleProps) {
  const inputId = id || rest.name || `sw-${Math.random().toString(36).slice(2)}`
  return (
    <label htmlFor={inputId} className="toggle">
      <input
        id={inputId}
        type="checkbox"
        checked={checked}
        onChange={(e) => onCheckedChange(e.target.checked)}
        {...rest}
      />
      <span className="toggle-track">
        <span className="toggle-thumb" />
      </span>
      {label ? (
        <span className="toggle-text">
          <span>{label}</span>
          {hint ? <small>{hint}</small> : null}
        </span>
      ) : null}
    </label>
  )
}
